// ### Imports
// * Import lib
import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useTheme } from "@emotion/react";

import { Stack } from "@mui/material";

// * Import custom components
import Card from "../../components/Card/Card";
import DescModal from "../../components/AccountSetupComponents/DescModal";

// * Import data & utils
import { jobRoleList } from "../../../assets/data/accountSetupData";

// * Import kits
import Typography from "../../kit/Typography";

// * Import actions
import { accountSetupJobRole } from "../../redux/slice/accountSetupSlice";

// * Import styles
import { accountSetupStyles } from "../../theme/style";
import UserTour from "../../components/UserTour/UserTour";
import { accountSetupStep4 } from "../../components/UserTour/Data/DiscoverSteps";
import otherJob from "../../../assets/images/signup_images/others-func.svg";

// # Component
const JobRoleContent = ({ templateData }) => {
  const dispatch = useDispatch();
  const theme = useTheme();
  const classes = accountSetupStyles(theme);
  const userJourney = useSelector((state) => state.auth.userJourney);
  let newUserPageFlag =
    userJourney?.isNewUser && userJourney?.pagesToShow?.["accountSetupJobRole"];
  const [open, setOpen] = useState(false);

  const selectedJobRole = useSelector((state) => state.accountSetup.jobRole);

  const jobRoleListNameExceptOthers = templateData?.options
    .filter((val) => val.name !== "Others")
    .map((val) => val.name);

  // # Handlers
  const handleClose = () => {
    setOpen(false);
  };

  const handleDone = (key, value) => {
    setOpen(false);
    dispatch(accountSetupJobRole(value));
  };

  const handleRoleChange = (key, val) => {
    if (jobRoleListNameExceptOthers.includes(val)) {
      dispatch(accountSetupJobRole(val));
    } else {
      setOpen(true);
    }
  };

  // # JSX
  return (
    <>
      <UserTour
        steps={accountSetupStep4}
        isOpen={userJourney?.showJourney || newUserPageFlag}
        page={"accountSetupJobRole"}
        newUserPageFlag={newUserPageFlag}
      />
      <DescModal
        jobRoleListNameExceptOthers={jobRoleListNameExceptOthers}
        selectedValue={selectedJobRole}
        handleClose={handleClose}
        open={open}
        type="job_role"
        handleDone={handleDone}
        keyField="job_role"
      />
      <div
        style={{
          display: "flex",
          height: "100%",
          flexDirection: "column",
        }}
      >
        <Stack
          sx={{
            display: "flex",
            alignItems: "center",
            flexDirection: "column",
          }}
        >
          <Typography
            align="center"
            sx={{
              textTransform: "uppercase",
              margin: theme.size[10],
              color: theme.palette.cards.heading,
            }}
          >
            {templateData?.Description}
          </Typography>
        </Stack>
        <div
          id={"jobRoleContent"}
          style={{
            display: "flex",
            height: "100%",
            flexDirection: "column",
          }}
        >
          <div
            className={classes.setupCardListFunctionContainer}
            style={{
              flexDirection: "column",
              gap: theme.sizeRem[3],
              height: "calc(100vh - 350px)",
              overflow: "auto",
            }}
          >
            <div
              className={classes.setupCardList}
              style={{ overflowY: "auto" }}
            >
              {templateData?.options.length &&
                templateData?.options.map((item) => {
                  const isOtherSelected =
                    item.name === "Others" &&
                    selectedJobRole !== "" &&
                    !jobRoleListNameExceptOthers.includes(selectedJobRole);

                  const jobRole = jobRoleList.find(
                    (role) => role.name === item.name
                  );
                  const icon = otherJob;
                  const displayStyle =
                    item.name === selectedJobRole || isOtherSelected
                      ? "block"
                      : "none";
                  return (
                    <Card
                      otherSelectedValue={selectedJobRole}
                      key={item.name}
                      handleChange={handleRoleChange}
                      keyField={"job_role"}
                      name={item.name}
                      info={item.description}
                      jobRoleListNameExceptOthers={jobRoleListNameExceptOthers}
                      isOtherSelected={isOtherSelected}
                      jobRole={jobRole}
                      icon={icon}
                      displayStyle={displayStyle}
                    />
                  );
                })}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

// # Exports
export default JobRoleContent;
